import { createContext } from 'react';
import { MouseInteractionContextType } from './types';

export const MouseInteractionContext = createContext<MouseInteractionContextType>({
  usingMouse: false,
});
